var $843964c3bf9a7d24$exports = {};
$843964c3bf9a7d24$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " er ikke valgt.");
  },
  "longPressToSelect": "Bruk et langt trykk for \xE5 g\xE5 inn i valgmodus.",
  "select": "Velg",
  "selectedAll": "Alle elementer er valgt.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Ingen elementer er valgt",
      one: function one() {
        return "".concat(formatter.number(args.count), " element er valgt");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementer er valgt");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " er valgt.");
  }
};
export { $843964c3bf9a7d24$exports as default };